var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from "@emotion/css";
var VerticalLine = function () {
    return (_jsx("span", { className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        height: 90%;\n        margin-left: 20px;\n        border-left: 1.5px solid #ccc;\n      "], ["\n        height: 90%;\n        margin-left: 20px;\n        border-left: 1.5px solid #ccc;\n      "]))) }));
};
export default VerticalLine;
var templateObject_1;
